 //  export const URL_SERVICIOS = 'http://localhost:3000';

// import { ActivationStart } from "@angular/router";
// import { TablapescadoresService } from "../services/tablapescador/tablapescadores.service";

//   export const URL_SERVICIOS = 'https://app.sportfishingmx.com';
  export const URL_SERVICIOS = 'https://smx.sportfishingmx.com';
// export const URL_SERVICIOS = 'https://app.mitoner.store';
  //  export const URL_SERVICIOS = 'https://167.71.20.223:3000';


  //

// 